import Beliefs from './Beliefs'

export default Beliefs
